// Mock data for Blanqo - Premium Dry Cleaning & Garment Care

export const heroSlides = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1549037173-e3b717902c57?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Professional Dry Cleaning",
    subtitle: "Handled with expert care",
  },
  {
    id: 2,
    image: "https://images.pexels.com/photos/4271700/pexels-photo-4271700.jpeg",
    title: "Revive Your Shoes & Bags",
    subtitle: "Premium restoration craftsmanship",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1520434901111-8e9bcb42c628?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Expert Cleaning & Care",
    subtitle: "Fabric-safe advanced techniques",
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1585241920473-b472eb9ffbae?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Bridal Elegance, Restored",
    subtitle: "Specialist couture garment care",
  },
];

export const services = [
  {
    id: "wedding",
    title: "Wedding Couture",
    description:
      "Specialized bridal and couture garment care that preserves intricate details, delicate fabrics, and embellishments. Perfect for pre-wedding preparation or post-event preservation.",
    image: "https://images.pexels.com/photos/20352730/pexels-photo-20352730.jpeg",
  },
  {
    id: "home",
    title: "Home & Fabrics",
    description:
      "Professional cleaning solutions for upholstery, curtains, carpets, and car interiors. Our service removes deep stains, dust, and allergens to keep your living and driving spaces fresh and hygienic.",
    image: "https://images.pexels.com/photos/7045703/pexels-photo-7045703.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "sneakers",
    title: "Sneakers & Bags",
    description:
      "Expert cleaning, conditioning, and restoration for premium shoes, handbags, and leather goods. We specialize in reviving worn items, extending their life while maintaining their luxury look and feel.",
    image: "https://images.pexels.com/photos/4271700/pexels-photo-4271700.jpeg",
  },
  {
    id: "garment",
    title: "Garment Care",
    description:
      "Premium garment care tailored for daily wear, delicate fabrics, and designer outfits. From washing and stain removal to fabric-specific cleaning and finishing, we ensure every piece stays fresh and refined.",
    image: "https://images.unsplash.com/photo-1562157873-818bc0726f68?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const pillars = [
  {
    id: 1,
    title: "Doorstep Convenience",
    description:
      "Hassle-free pickup and delivery from your home, ensuring your garments are handled with care from start to finish.",
    icon: "Truck",
  },
  {
    id: 2,
    title: "Fabric-Safe Cleaning",
    description:
      "Advanced stain removal and cleaning techniques, customized for each fabric to maintain color, texture, and durability.",
    icon: "Sparkles",
  },
  {
    id: 3,
    title: "Advanced Technology",
    description:
      "Innovative cleaning techniques combined with careful fabric handling to ensure superior, long-lasting freshness.",
    icon: "ShieldCheck",
  },
];

export const processSteps = [
  {
    step: "01",
    title: "Inspection & Stain Mapping",
    description:
      "Each garment is inspected and stains are identified for safe, effective treatment.",
    icon: "Search",
  },
  {
    step: "02",
    title: "Fabric-safe Cleaning",
    description:
      "Specialized dry and wet cleaning methods tailored to protect every fabric type.",
    icon: "Droplets",
  },
  {
    step: "03",
    title: "Finishing & Steaming",
    description:
      "Expert finishing and steaming to restore shape, softness, and pristine appearance.",
    icon: "Wind",
  },
  {
    step: "04",
    title: "QC & Premium Packaging",
    description:
      "Thorough quality checks followed by hygienic, elegant packaging for lasting freshness.",
    icon: "PackageCheck",
  },
];

export const cities = ["West Hyderabad"];

export const testimonials = [
  {
    id: 1,
    name: "Swaroop Sharma",
    location: "Banjara Hills, Hyderabad",
    quote:
      "Blanqo has genuinely excellent services. Now I don't worry about stains on my clothes as I am confident Blanqo will remove them. It is my preferred laundry place.",
  },
  {
    id: 2,
    name: "Chandni Srivatsav",
    location: "Banjara Hills, Hyderabad",
    quote:
      "I really like Blanqo and appreciate the service and staff. The work done here is very professional and they make customers feel reassured and comfortable.",
  },
];

export const serviceOptions = [
  "Dry Cleaning",
  "Laundry",
  "Wedding Couture",
  "Shoe Cleaning",
  "Bag Restoration",
  "Curtain & Upholstery",
  "Carpet Cleaning",
];

export const stateOptions = [
  "Maharashtra",
  "Delhi",
  "Karnataka",
  "Telangana",
  "Rajasthan",
  "Gujarat",
  "West Bengal",
];
